import {
  GoogleMap,
  Marker,
  InfoWindow,
  LoadScript,
} from "@react-google-maps/api";
import PropTypes from "prop-types";
import { useState } from "react";
import { Google_Map_Api_Key } from "../api/devprofile";

interface MarkerType {
  lat: number;
  lng: number;
  pg_name: string;
  price: string;
  area: string;
  imageUrl: string;
}

interface MapComponentProps {
  markerList: MarkerType[];
  initialCenter: { lat: number; lng: number };
}

const mapContainerStyle = {
  width: "100%",
  height: "400px",
};

const MapComponent: React.FC<MapComponentProps> = ({
  markerList,
  initialCenter,
}) => {
  const [selectedMarker, setSelectedMarker] = useState<MarkerType | null>(null);
  console.log(markerList, ":::::::::markerList");

  const handleMarkerClick = (marker: MarkerType) => {
    setSelectedMarker(marker);
  };

  const handleDirection = (lat: number, lng: number) => {
    const url = `https://www.google.com/maps/dir/?api=1&destination=${lat},${lng}`;
    window.open(url, "_blank");
  };

  return (
    <LoadScript
      googleMapsApiKey={Google_Map_Api_Key}
      libraries={["places"]}
      onLoad={() => console.log("Google Maps Loaded")}
    >
      <GoogleMap
        mapContainerStyle={mapContainerStyle}
        zoom={13}
        center={initialCenter} // Use initialCenter prop
      >
        {markerList.map((marker, index) => (
          <Marker
            key={index}
            position={{ lat: marker.lat, lng: marker.lng }}
            onClick={() => handleMarkerClick(marker)}
          />
        ))}

        {selectedMarker && (
          <InfoWindow
            position={{ lat: selectedMarker.lat, lng: selectedMarker.lng }}
            onCloseClick={() => setSelectedMarker(null)}
          >
            <div
              onClick={() =>
                handleDirection(selectedMarker.lat, selectedMarker.lng)
              }
              style={{ cursor: "pointer" }}
            >
              <img
                src={selectedMarker.imageUrl}
                alt={selectedMarker.pg_name}
                style={{ borderRadius: 45, width: 90, height: 90 }}
              />
              <h3>{selectedMarker.pg_name}</h3>
              <p>₹ {selectedMarker.price}</p>
              <p>{selectedMarker.area}</p>
              <span style={{ color: "blue", textDecoration: "underline" }}>
                Get Directions
              </span>
            </div>
          </InfoWindow>
        )}
      </GoogleMap>
    </LoadScript>
  );
};

MapComponent.propTypes = {
  markerList: PropTypes.array.isRequired,
  initialCenter: PropTypes.shape({
    lat: PropTypes.number.isRequired,
    lng: PropTypes.number.isRequired,
  }).isRequired,
};

export default MapComponent;